
import React, {Component} from 'react'
import Select from 'react-select'
import { Button } from "reactstrap";

const translator = require('../../utils/translator/translator');
const stringUtil = require('../../utils/string/stringUtil');
const constants = require('../../utils/domain/constants');
const storefrontUtility = require('../../utils/domain/storefrontUtility');

const customStyles = 
        {
            control: (provided, state) => ({
                ...provided,
                minHeight: '6vh',
                height: '6vh',
                borderColor: 'var(--colors-primary)',
            }),
            menu: provided => ({ ...provided, zIndex: 9999}),
        };

class SaleFilterView extends Component 
{
    constructor(props)
    {
        super(props);

        this.state = {};
        this.state.result = {};
    }

    render()
    {
        return <div className='h-100 d-flex flex-column'>
                    <div style={{marginBottom: '30px'}}>
                        <Button block className='btn-action'
                                onClick={()=>
                                {
                                    this.props.onApply();
                                }}>
                                    {translator.getLabel("apply")}
                        </Button>
                    </div>
                    <div className='h-100' style={{overflowY:'auto'}}>
                        {this.renderAttributesView()}
                    </div>
                </div>
        
    }

    renderAttributesView()
    {

        return <div>
                    {this.renderDispatchTypes()}
                    <div style={{marginBottom:'30px'}}/>
                    
                    {this.renderVenueCodeCriteria()}
                    <div style={{marginBottom:'30px'}}/>
                    
                    {this.renderPaymentStatus()}
                    <div style={{marginBottom:'30px'}}/>

                    {this.renderStorefronts()}
                    <div style={{marginBottom:'30px'}}/>

                    {this.renderSaleStatus()}
                </div>
    }

    renderPaymentStatus()
    {
        const options = [
            { value: 'paid', label: translator.getLabel("paid") },
            { value: 'unpaid', label: translator.getLabel("not_paid") }
          ]


        let selectedValue = null;
        if (!stringUtil.isStringNullOrEmpty(this.props.filterCriteria.paymentStatus))
          selectedValue = options.find(o => stringUtil.areStringSame(o.value, this.props.filterCriteria.paymentStatus));
       
        return <div>
                    <div style={{fontWeight:'bold', marginBottom:'5px'}}>{translator.getLabel("payment_status")}</div>
                    <Select options={options} value={selectedValue} placeholder={translator.getLabel("all")} 
                            isSearchable={false}
                            isClearable={true}
                            onChange={(selectedValue) =>
                                {
                                    if (selectedValue == null)
                                    {
                                        this.props.filterCriteria.paymentStatus = null;
                                        this.setState({});
                                        return;
                                    }
                                    this.props.filterCriteria.paymentStatus = selectedValue.value;
                                    this.setState({});
                                }}
                    styles={customStyles}/>
                </div>
    }

    renderDispatchTypes()
    {
        const options = [
            { value: constants.DispatchTypeCollection, label: translator.getLabel("collection") },
            { value: constants.DispatchTypeDelivery, label: translator.getLabel("delivery") },
            { value: constants.DispatchTypeDineIn, label: translator.getLabel("dineIn") },
            { value: constants.DispatchTypeTakeAway, label: translator.getLabel("takeAway") },
          ]

          let selectedValue = null;
          if (!stringUtil.isStringNullOrEmpty(this.props.filterCriteria.dispatchType))
            selectedValue = options.find(o => stringUtil.areStringSame(o.value, this.props.filterCriteria.dispatchType));
         
          return <div>
                      <div style={{fontWeight:'bold', marginBottom:'5px'}}>{translator.getLabel("dispatch")}</div>
                      <Select 
                        options={options} value={selectedValue} placeholder={translator.getLabel("all")} 
                        isClearable={true}
                        isSearchable={false}
                        onChange={(selectedValue) =>
                            {
                                if (selectedValue == null)
                                {
                                    this.props.filterCriteria.dispatchType = null;
                                    this.setState({});
                                        return;
                                    }
                                    this.props.filterCriteria.dispatchType = selectedValue.value;
                                    this.setState({});
                                }}
                        styles={customStyles}/>
                  </div>
    }

    renderVenueCodeCriteria()
    {
        const options = [
            { value: 'Property', label: constants.VenueCodeProperty },
            { value: constants.VenueCodeFlipdish, label: constants.VenueCodeFlipdish },
            { value: constants.VenueCodeDeliveroo, label: constants.VenueCodeDeliveroo },
            { value: constants.VenueCodeUberEats, label: constants.VenueCodeUberEats },
            { value: constants.VenueCodeJustEats, label: constants.VenueCodeJustEats },
            { value: constants.VenueCodeMobileApp, label: constants.VenueCodeMobileApp },
            { value: constants.VenueCodeWebApp, label: constants.VenueCodeWebApp },
            { value: constants.VenueCodeExternalApp, label: constants.VenueCodeExternalApp },
          ]

          let selectedValue = null;
          if (!stringUtil.isStringNullOrEmpty(this.props.filterCriteria.venueCode))
            selectedValue = options.find(o => stringUtil.areStringSame(o.value, this.props.filterCriteria.venueCode));
         
        return <div>
            <div style={{ fontWeight: 'bold', marginBottom: '5px' }}>{translator.getLabel("venue")}</div>
            <Select options={options} value={selectedValue} placeholder={translator.getLabel("all")}
                isClearable={true}
                isSearchable={false}
                onChange={(selectedValue) =>
                {
                    if (selectedValue == null)
                    {
                        this.props.filterCriteria.venueCode = null;
                        this.setState({});
                        return;
                    }
                    this.props.filterCriteria.venueCode = selectedValue.value;
                    this.setState({});
                }}
                styles={customStyles}/>
        </div>
    }

    

    renderStorefronts()
    {
        const options = [];

        storefrontUtility.getAllStorefronts().forEach(storefront =>
        {
            let option = {};
            option.value = storefront.id;
            option.label = storefront.name;
            options.push(option);
        });

        let selectedValue = null;
        if (!stringUtil.isStringNullOrEmpty(this.props.filterCriteria.storefrontId))
            selectedValue = options.find(o => stringUtil.areStringSame(o.value, this.props.filterCriteria.storefrontId));
        
        return <div>
            <div style={{ fontWeight: 'bold', marginBottom: '5px' }}>{translator.getLabel("storefront")}</div>
            <Select options={options} value={selectedValue} placeholder={translator.getLabel("all")}
                isClearable={true}
                isSearchable={false}
                onChange={(selectedValue) =>
                {
                    if (selectedValue == null)
                    {
                        this.props.filterCriteria.storefrontId = null;
                        this.setState({});
                        return;
                    }
                    this.props.filterCriteria.storefrontId = selectedValue.value;
                    this.setState({});
                }}
                menuPlacement='top'
                styles={customStyles}/>
        </div>
    }

    renderSaleStatus()
    {
        const options = [
            { value: "active", label: "Active" },
            { value: "cancelled", label: "Cancelled" },
            { value: "hold", label: "Hold" },
          ]

          let selectedValue = null;
          if (!stringUtil.isStringNullOrEmpty(this.props.filterCriteria.saleStatus))
            selectedValue = options.find(o => stringUtil.areStringSame(o.value, this.props.filterCriteria.saleStatus));
         
          return <div>
                      <div style={{fontWeight:'bold', marginBottom:'5px'}}>Status</div>
                      <Select 
                        options={options} value={selectedValue} placeholder={translator.getLabel("all")} 
                        isClearable={true}
                        isSearchable={false}
                        onChange={(selectedValue) =>
                            {
                                if (selectedValue == null)
                                {
                                    this.props.filterCriteria.saleStatus = null;
                                    this.setState({});
                                    return;
                                }
                                this.props.filterCriteria.saleStatus = selectedValue.value;
                                this.setState({});
                            }}
                        menuPlacement='top'
                        styles={customStyles}/>
                  </div>
    }
}

export default SaleFilterView
